(function () {
  class PreCheckoutUpsell {
    constructor() {
      this.modal = document.getElementById('pre-checkout-upsell-popup');
      if (!this.modal) return;

      this.variantId = parseInt(this.modal.dataset.variantId, 10);
      if (!this.variantId) return;

      this.productHandle = this.modal.dataset.productHandle;
      this.isProcessing = false;
      this.pendingProceed = null;

      this.bindEvents();
      this.ensurePricing();
      window.PreCheckoutUpsell = this;
    }

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.money_format);
      }

      return `$${(cents / 100).toFixed(2)}`;
    }

    async ensurePricing() {
      const amountEl = this.modal.querySelector('.pre-checkout-upsell__amount');
      const addLabel = this.modal.querySelector('[data-pre-checkout-add-label]');

      if (amountEl?.textContent?.trim()) return;

      if (!this.productHandle) return;

      try {
        const response = await fetch(`/products/${this.productHandle}.js`);
        if (!response.ok) return;

        const product = await response.json();
        const variant =
          product.variants.find((item) => item.id === this.variantId) || product.variants[0];

        if (!variant) return;

        const compareEl = this.modal.querySelector('.pre-checkout-upsell__compare');
        const formattedPrice = this.formatMoney(variant.price);

        if (amountEl) amountEl.textContent = formattedPrice;
        if (addLabel) addLabel.textContent = `Yes, add to my order — ${formattedPrice}`;

        if (variant.compare_at_price && variant.compare_at_price > variant.price && compareEl) {
          compareEl.innerHTML = `<s>${this.formatMoney(variant.compare_at_price)}</s>`;
        }
      } catch (error) {
        console.error('Pre-checkout upsell price load failed:', error);
      }
    }

    bindEvents() {
      document.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('#cart-sidebar-checkout');
          if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const checkoutHref = this.getCheckoutHref(button);
          this.handleCheckout(checkoutHref, () => {
            window.location = checkoutHref;
          });
        },
        true
      );

      this.modal.querySelector('[data-pre-checkout-add]')?.addEventListener('click', () => {
        this.addAndProceed();
      });

      this.modal.querySelector('[data-pre-checkout-decline]')?.addEventListener('click', () => {
        this.decline();
      });

      this.modal.querySelector('[data-pre-checkout-close]')?.addEventListener('click', () => {
        this.decline();
      });

      document.addEventListener('click', (event) => {
        if (!document.body.classList.contains('pre-checkout-upsell-show')) return;
        if (event.target.closest('#pre-checkout-upsell-popup')) return;
        if (event.target.closest('.background-overlay')) {
          this.decline();
        }
      });
    }

    getCheckoutHref(button) {
      return button?.getAttribute('href') || button?.dataset?.href || `${window.routes?.root || ''}/checkout`;
    }

    async interceptCartPage(checkoutHref, proceedFn) {
      await this.handleCheckout(checkoutHref, proceedFn);
    }

    async handleCheckout(checkoutHref, proceedFn) {
      if (this.isProcessing) return;

      try {
        this.isProcessing = true;
        const cart = await fetch('/cart.js').then((response) => response.json());

        if (this.isVariantInCart(cart)) {
          this.isProcessing = false;
          await proceedFn();
          return;
        }

        this.pendingProceed = proceedFn;
        this.showModal();
      } catch (error) {
        console.error('Pre-checkout upsell cart check failed:', error);
        this.isProcessing = false;
        await proceedFn();
      }
    }

    isVariantInCart(cart) {
      return cart.items.some((item) => item.variant_id === this.variantId);
    }

    showModal() {
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pre-checkout-upsell-show');
    }

    hideModal() {
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pre-checkout-upsell-show');
    }

    async addAndProceed() {
      const addButton = this.modal.querySelector('[data-pre-checkout-add]');
      if (addButton?.classList.contains('is-loading')) return;

      addButton?.classList.add('is-loading');

      try {
        const addResponse = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: this.variantId, quantity: 1 }],
          }),
        });

        if (!addResponse.ok) {
          throw new Error('Unable to add upsell product');
        }

        const cart = await fetch('/cart.js').then((response) => response.json());
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        if (window.sharedFunctions?.updateSidebarCart) {
          window.sharedFunctions.updateSidebarCart(cart);
        }

        this.finishCheckoutFlow();
      } catch (error) {
        console.error('Pre-checkout upsell add failed:', error);
        addButton?.classList.remove('is-loading');
        this.finishCheckoutFlow();
      }
    }

    decline() {
      this.finishCheckoutFlow();
    }

    finishCheckoutFlow() {
      this.hideModal();
      this.modal.querySelector('[data-pre-checkout-add]')?.classList.remove('is-loading');

      const proceed = this.pendingProceed;
      this.pendingProceed = null;
      this.isProcessing = false;

      if (proceed) proceed();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new PreCheckoutUpsell();
  });
})();
